<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wBYo2j/tc-custom/9781642500318.jpg?1728851752722" alt="This image is the cover for the book Your Next Level Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Your Next Level Life
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The award-winning guide to help Black women knock down barriers, level up their career, income, and lifestyle, and live life on their terms.<br/><br/> Channel your Black girl magic:</b> If you’re feeling stuck or trapped by other people’s expectations of what you can achieve, it’s time to stop playing small and start redefining what success can mean for you. It’s time to get that upgrade. Karen Arrington―founder of the Miss Black USA Pageant, creator of the Next Level Women’s Summit, and mentor to thousands of confident, successful young black women―is your guide to getting your next level life.<br/><br/><b>Leave a legacy of black excellence:</b> With the seven simple rules, you’ll learn how to bring your career, income, and lifestyle to that next level. Don’t settle for a life of invisibility and mediocrity. Set ambitious goals, reach for bigger opportunities, and know that you are brave enough to get what you deserve.<br/><br/> The rules of success in <i>Your Next Level Life</i> will show you how to:</p><p>·       Create all the money you need<br/> ·       Position yourself like a star<br/> ·       Connect with other powerful women<br/><br/><b>Give a gift of confidence:</b> For anyone looking for inspirational gifts for women in their lives, <i>Your Next Level Life</i> is unlike other self-help books for women. It’s a guide to opportunity that recognizes and celebrates the true magic of ambitious Black women.<br/><br/><b>Winner NAACP Image Award for Outstanding Instructional Literary Work<br/><br/> Perfect for readers of personal development books like <i>The Big Leap</i>,<i> Year of Yes</i>,<i> Believe Bigger</i>, and <i>Don’t Settle for Safe</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Arrington
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76a9135d